import { FullscreenButton } from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullscreenButton/FullscreenButton';
import FullScreenGallery from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullScreenGallery/FullScreenGallery';
import {
  FullscreenContainerSt,
  FullScreenSlidesSt,
  MobileFullscreenButtonSt,
  SlideFullscreenSt,
  SlideHeaderSt,
  SlideContainerSt,
} from './FullScreenSlides.css';
import { useState } from 'react';
import FullScreenList from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullScreenList/FullScreenList';
import Slider from 'app/shared/components/MediaGallery/components/MediaSlider/components/Slider/Slider';

const FullScreenSlides = ({
  offset,
  items,
  handleBackClick,
  handleNextClick,
  withBackground,
  onImageSlideClick,
  disableFullscreen,
  handleMediaGalleryClick,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <FullscreenContainerSt>
      <MobileFullscreenButtonSt>
        <FullscreenButton
          onClose={disableFullscreen}
          data-testid="image-gallery-full-screen"
        />
      </MobileFullscreenButtonSt>
      <FullScreenSlidesSt withBackground={withBackground}>
        <SlideFullscreenSt>
          <SlideHeaderSt>
            <FullscreenButton
              onClose={disableFullscreen}
              data-testid="image-gallery-full-screen"
            />
          </SlideHeaderSt>
          <SlideContainerSt>
            <Slider
              handleBackClick={handleBackClick}
              handleNextClick={handleNextClick}
            >
              <FullScreenList
                items={items}
                offset={offset}
                onImageSlideClick={onImageSlideClick}
                setIsPlaying={setIsPlaying}
                isPlaying={isPlaying}
                withBackground={withBackground}
              />
            </Slider>
            <FullScreenGallery
              items={items}
              offset={offset}
              handleBackClick={handleBackClick}
              handleNextClick={handleNextClick}
              handleMediaGalleryClick={handleMediaGalleryClick}
            />
          </SlideContainerSt>
        </SlideFullscreenSt>
      </FullScreenSlidesSt>
    </FullscreenContainerSt>
  );
};

export default FullScreenSlides;
